import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IconComponent } from '../icon/icon.component';

export interface AvatarOptions {
  type: AvatarOptionsType;
  href?: string;
  initials?: string;
  color_class?: string;
}

export enum AvatarOptionsType {
  Uploaded = 'uploaded',
  Initials = 'initials',
}

export enum AvatarType {
  Org = 'org',
  User = 'user',
}

export enum AvatarSize {
  ExtraSmall = 'extra-small',
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

/**
 * This component handles all of our avatar use cases. It covers org and user
 * types, default and image uploaded version, along with the special community avatar.
 *
 * This currently depends on a complex configuration object, but represents the
 * implementations we currently see in webapp.
 */
@Component({
  standalone: true,
  selector: 'capra-avatar',
  imports: [CommonModule, IconComponent],
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarComponent {
  /** The avatar type `(org | user)` determines avatar style, specifically the border radius */
  @Input() type = AvatarType.Org;

  /** The avatar size `(small | medium | large)` */
  @Input() size = AvatarSize.Small;

  /** The avatar options object, content varied based on whether the avatar options has type `initials` or `uploaded`
   * `{ type: string; href?: string; initials?: string; color_class?: string; }`
   */
  @Input() options: AvatarOptions | undefined;

  /** An optional input when "true", the community-blue icon is displayed */
  @Input() community = false;

  /**
   * Determine if an image is present in the options
   */
  get hasImage() {
    return this.options && this.options.href;
  }
}
